$(document).ready(function (params) {
  $(".cc-features-use-slider").slick({
    // fade: true,
    slide: ".slide",
    infinite: true,
    swipe: true,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    dots: false,
    pauseOnHover:false,
    adaptiveHeight: true,
  });

  // Add custom progress bar
  $(".cc-features-use-slider").on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var progress = (nextSlide + 1) * (100 / slick.slideCount) + '%';
      $('.custom_features .slick-progress span').css('width', progress);
  });
});
